<template>
    <div>
        <el-table :data="tabledata" :border='true'>
            <el-table-column prop="projectId" label="审核结果" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.projectName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="stationId" label="审核备注" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.stationName || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="ammeterId" label="审核时间" min-width="140">
                <template slot-scope="{ row }">
                    <span>{{ row.ammeterNo || '-' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="billId" label="审核人" min-width="160" >
                <template slot-scope="{ row }">
                    <span>{{ row.lastRecordTime || '-' }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    export default {
        data() {
            return {
                util: util,
            }
        },
        props:{
            tabledata: {
                default: ()=>{
                    return []
                }
            }
        },
        methods:{
            
        }
    }
</script>